import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/fonts/font.css'

import '@/modules/chemical/assets/reset.css';
import '@/modules/chemical/style/index.css';

import '@/modules/shop/style/index.css';

import '@/modules/resource/style/index.css';

import router from './router';
import store from './store'
import { initSlsLogger } from '@/modules/chemical/utils/slsLogger'

// 初始化 SLS 前端日志上报（拦截 console 批量上传）
initSlsLogger();

// 强制打开devtools
Vue.config.devtools = true;
Vue.use(ElementUI);

new Vue({
  router,
  render: h => h(App),
  store
}).$mount('#app');